import { __extends } from "tslib";
var SettingsProviderIsNotReadyError = /** @class */ (function (_super) {
    __extends(SettingsProviderIsNotReadyError, _super);
    function SettingsProviderIsNotReadyError() {
        var _newTarget = this.constructor;
        var _this = _super.call(this, "\nSettingsProvider is not ready.\nUsually this case should be unreachable.  \nIn case you face it use \"context.ready: boolean\" flag not determine if it possible to set/get params. \n") || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return SettingsProviderIsNotReadyError;
}(Error));
export { SettingsProviderIsNotReadyError };
//# sourceMappingURL=SettingsProviderIsNotReadyError.js.map